export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-23.b939a1ac.jpg";